import { ResHelper } from '@/helper/ResHelper';

export default function convertCentsToDecimalNumber(cents: number, fractionDigits: number): string {
    return Number(cents / 100).toLocaleString(ResHelper.getCurrentCultureName(), {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    });
}
